import React, { useEffect, useRef, useState, useMemo } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/management.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import "../assets/css/report.css"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
faPlus,
faSort,
faTrash,
faPenToSquare,
faTimes,
faExclamationTriangle,
faDownload,
faEllipsisV, 
faSearch,
faFileImport,
faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {commonAPI} from "../services/CommonAPIService"
import {ErrorSource} from '../common/constants'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Menus from "./menus";
import Table from 'react-bootstrap/Table';
import success from '../assets/img/success.png';
import unmapRfid from "../assets/img/rfid.png";
function ManageUserRfid() {
    const [show, setShow] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [RFIDTagData, setRFIDTagData] = useState("")
    const [IsMapped, setIsMapped] = useState(false);
    const [VehicleType, setVehicleType] = useState("4WHEELER");
    const [LotNumber, setLotNumber] = useState("");
    const [Serialnumber, setSerialnumber] = useState("");
    const [TagId, setTagId] = useState("");
    const [SerialnumberDelete, setSerialnumberDelete] = useState("");
    const [TagIdDelete, setTagIdDelete] = useState("");
    const [RFIDCardId, setRFIDCardId] = useState("");
    const [IsIssued, setIsIssued] = useState(false);
    const [IsIssuedDisable, setIsIssuedDisable] = useState(true);
    const [UpdateBtn, setUpdateBtn] = useState(false);
    const [DeleteShow, setDeleteShow] = useState(false);
    const [UnmapShow, setUnmapShow] = useState(false);
    const [ImportXlData, setImportXlData] = useState("");
    const [DuplicateDataShow, setDuplicateDataShow] = useState(false);
    const [ErrorDataShow, setErrorDataShow] = useState(false);
    const [SuccessShow, setSuccessShow] = useState(false);
    const [BrowesShow, setBrowesShow] = useState(true);
    const [IndexState, setIndexState] = useState(null);
    const [BuildingId, setBuildingId] = useState("")
    const [BuildingList, setBuildingList] = useState("")
    const [slideshowHeight, setSlideshowHeight] = useState(0);
    const MasterUrl = process.env.REACT_APP_MASTER_API 
    console.log("file", file)
    console.log("IsMapped", IsMapped)

    const updateSlideshowHeight = () => {
        const winHeight = window.innerHeight; // Get the window height
        setSlideshowHeight(winHeight - 250); // Set the slideshow height
    };
    
    useEffect(() => {
        updateSlideshowHeight();
        window.addEventListener('resize', updateSlideshowHeight);

        return () => {
            window.removeEventListener('resize', updateSlideshowHeight);
        };
    }, []);

    function ImageUpload() {
        const [selectedImage, setSelectedImage] = useState(null);
        const handleFileInputChange = (event) => {
        const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                var base64result = reader.result.substr(reader.result.indexOf(",") + 1);
                reader.onload = () => {
                setSelectedImage(base64result);
            };
                console.log("base64", base64result);
                reader.readAsDataURL(file);
            }
        };
    }
    const convertISTTime = (date) => {
        if (date != null || date != "" || date != undefined) {
            const [datePart, TimePart] = date.split(" ");
            const [yyyy, mm, dd] = datePart.split("-");
            // const [hh, mn, ss] = TimePart.split(':')
            const formatedTime = `${mm}/${dd}/${yyyy}`;
            return formatedTime;
        } else {
            console.warn("input date string may be null, empty string or undefined");
        }
    };

    const UploadSheet = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            setLoading(true);
            let response = await commonAPI("ImportTags")
            setLoading(true);
            console.log("responsebody", response);
            if(response?.success == true && response?.message?.length == 0){
                toast.success("Sheet Upload");
                
            }else{
                toast.error(response.message[0]);
                setLoading(false);
            }   
            
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/User/DeleteUserOrFamily",
                "errorNumber": "DC01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "ManageRFID.js",
                "functionName": "UploadSheet",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }   
    }

    const GetBuildingList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const auth2 = localStorage.getItem("primeProductCode");
        const ProductfactorKey = JSON.parse(auth2);
        const endPointVariableKey = {
            ProductId: ProductfactorKey?.primeProductCode,
        }
        try {
            // setLoading(true);
            let response = await commonAPI("BuildingLite", undefined, endPointVariableKey)
            if (response?.success===true){
                setBuildingList(response?.data);
                setLoading(false);
            }else{
                toast.error("Something went wrong");
                setLoading(false);
            }
    
        } catch (error) {
            console.log(error);
            setLoading(false);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            const bodyError = { 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Master/Building",
                "errorNumber": "BL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "flat.js",
                "functionName": "GetBuildingList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    
      } 
    
      useEffect(() => {
        GetBuildingList();
    
      }, []);
    
      useEffect(() => {        
        (async function(){
            const BuildingAuth = localStorage.getItem("BuildingId");
            const myBuildingId = JSON.parse(BuildingAuth);
            if(myBuildingId){
                setBuildingId(myBuildingId);
                console.log("building Id", myBuildingId)
            }    
        })()
    }, [])
    
      useEffect(() => {
        ClearValue();
        if(BuildingId){
            RFIDTagList();
            setRFIDTagData("");
            (async function(){
                await localStorage.setItem("BuildingId", BuildingId);
            })()
        }else if (BuildingId == ""){
            setRFIDTagData("");
            ClearValue();
        }
    }, [BuildingId])


    const RFIDTagList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            setLoading(true);
            const endPointVariableKey = {
                urlVariable: `${IsMapped}`,
                buildingId: BuildingId
            }
            let response = await commonAPI("UserTag", undefined, endPointVariableKey)
            setLoading(true);
            console.log("UserTagList response", response);
            if(response?.success == true && response?.message?.length == 0){
                setRFIDTagData(response?.data)
                setLoading(false);
            }else{
                toast.error(response?.message[0]);
                setLoading(false);
            }   
            
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Vehicle/RFIDTag",
                "errorNumber": "DC01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "ManageRFID.js",
                "functionName": "UploadSheet",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }   
    }
    
    useEffect(() => {
        if(BuildingId){
            RFIDTagList();
        }
        ClearValue();
    }, [IsMapped])

    const RFIDTagAdd = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData =
        {
            "createdUserId": myUserData?.userId.toString(),
            "lotNumber": LotNumber,
            "tagSerialNumber": Serialnumber,
            "tagId": TagId,
        }
        try {
            setLoading(true);
            if(!BuildingId){
                toast.warning("Please select Building");
                setLoading(false);
            }else if(!LotNumber){
                toast.warning("Please enter Lot Number");    
                setLoading(false);    
            }else if(!Serialnumber){
                toast.warning("Please enter Serial Number");     
                setLoading(false);
            }else if(!TagId){
                toast.warning("Please enter Tag Id");  
                setLoading(false);
            }else{
                const endPointVariableKey = {
                    buildingId: BuildingId
                }
                let response = await commonAPI("UserTagAdd", bodyData, endPointVariableKey)
                setLoading(true);
                console.log("RFIDTag Add response", response, bodyData);
                if(response?.success == true && response?.message?.length == 0){
                    toast.success("User Tag Added");
                    RFIDTagList();
                    setLotNumber("");
                    setSerialnumber("");
                    setTagId("");
                    setLoading(false);
                    setIndexState(null)
                }else{
                    toast.error(response?.message[0]);
                    setLoading(false);
                }   
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Vehicle/RFIDTag",
                "errorNumber": "TA01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "ManageRFID.js",
                "functionName": "UploadSheet",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }   
    }

    const OpenModal = () => {
        if(BuildingId){
            setShow(true)
            setBrowesShow(true) 
            setSuccessShow(false) 
            setDuplicateDataShow(false) 
            setErrorDataShow(false)
            setFile("") 
            ClearValue()
        }else{
            toast.warning("Please select Building");
        }    
        
    }

    const ClearValue = () => {
        setLotNumber("");
        setSerialnumber("");
        setTagId("");
        // setVehicleType("4WHEELER");
        setRFIDCardId("");
        setIsIssued(false)
        setUpdateBtn(false);
        setIsIssuedDisable(true);
        setIndexState(null)
    }

    const UpdateValue = (item, index) => {
        console.log("item", item, index)
        setLotNumber(item?.lotNumber);
        setSerialnumber(item?.tagSerialNumber);
        setTagId(item?.tagId);
        setVehicleType(item?.vehicleType);
        setRFIDCardId(item?.userTagId);
        setIsIssued((item?.isIssued == null || item?.isIssued == false ) ? false : true)
        setUpdateBtn(true);
        setIsIssuedDisable(false);
        setIndexState(index)
    }

    const RFIDTagUpdate = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData =
        {
            "userTagId": RFIDCardId,
            "modifiedUserId": myUserData?.userId.toString(),
            "lotNumber": LotNumber,
            "tagSerialNumber": Serialnumber,
            "tagId": TagId,
            // "secretCode": IsIssued == "true" ? true : false
        }
        try {
            setLoading(true);
            if(!BuildingId){
                toast.warning("Please select Building");
                setLoading(false);
            }else if(!LotNumber){
                toast.warning("Please enter Lot Number");    
                setLoading(false);   
            }else if(!Serialnumber){
                toast.warning("Please enter Serial Number");     
                setLoading(false);
            }else if(!TagId){
                toast.warning("Please enter Tag Id");  
                setLoading(false);
            }else{
                const endPointVariableKey = {
                    buildingId: BuildingId
                }
                let response = await commonAPI("UserTagUpdate", bodyData, endPointVariableKey)
                setLoading(true);
                console.log("UserTagUpdate Update response", response, bodyData);
                if(response?.success == true && response?.message?.length == 0){
                    toast.success("User Tag Updated");
                    RFIDTagList();
                    setLotNumber("");
                    setSerialnumber("");
                    setTagId("");
                    setUpdateBtn(false);
                    setLoading(false);
                    setIsIssuedDisable(true);
                    setIndexState(null)
                }else{
                    toast.error(response?.message[0]);
                    setLoading(false);
                    setIndexState(null)
                }   
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Vehicle/RFIDTag",
                "errorNumber": "TA01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "ManageRFID.js",
                "functionName": "RFIDTagUpdate",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }   
    }

    const DeleteValue = (item) => {
        console.log("item", item)
        setSerialnumberDelete(item?.tagSerialNumber);
        setTagIdDelete(item?.tagId);
        setRFIDCardId(item?.userTagId)
        setDeleteShow(true);
    }

    const RFIDTagDelete = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData =
        {
            "userTagId": RFIDCardId,
            "modifiedUserId": myUserData?.userId?.toString(),
            "tagSerialNumber": SerialnumberDelete,
            "tagId": TagIdDelete,
        }
        try {
            setLoading(true);
            const endPointVariableKey = {
                buildingId: BuildingId
            }
            let response = await commonAPI("DeleteUserTag", bodyData, endPointVariableKey)
            setLoading(true);
            console.log("DeleteUserTag Update response", response, bodyData);
            if(response.success == true && response.message.length == 0){
                toast.success("User Tag Deleted");
                RFIDTagList();
                setDeleteShow(false);
                setLoading(false);
                ClearValue();
                setIndexState(null)
            }else{
                toast.error(response?.message[0]);
                setLoading(false);
                setIndexState(null)
            }   
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Vehicle/DeleteRFIDTag",
                "errorNumber": "DT01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "ManageRFID.js",
                "functionName": "RFIDTagDelete",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }   
    }

    const RFIDTagImport = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);

        const authtoken = localStorage.getItem("token");
        const tokenAuth = JSON.parse(authtoken);
        console.log("tokenAuth", tokenAuth?.token)
        const formData = new FormData();
        formData.append('file', file);
    
        try {
            setLoading(true);
    
            
            if(!file){
                toast.warning("Please select file");
                setLoading(false);
            }else{
                const response = await fetch(`${MasterUrl}/api/Utility/ImportUserTags`, {
                // const response = await fetch('https://api.curonext.com/api/Utility/ImportTags', {    
                    method: 'POST',
                    body: formData,
                    headers: {
                        'Accept': 'application/json',
                        "buildingId": BuildingId,
                        // "AppSecretKey": BuildingId,
                        "Authorization": `Bearer ${tokenAuth?.token}`
                    }
                });
        
                const result = await response.json();
                // const endPointVariableKey = {
                //     buildingId: BuildingId
                // }
                // let result = await commonAPI("ImportUserTags", formData, endPointVariableKey)

                console.log("ImportUserTags", result, formData);
                if (result?.success === true && result?.message?.length === 0) {
                    setLoading(false);
                    // toast.success("Sheet Imported");
                    if(result?.data?.importResponseData?.length == 0){
                        setSuccessShow(true)
                        setDuplicateDataShow(false);
                        setErrorDataShow(false)
                        // setBrowesShow(false);
                        // setFile("")
                    }else if(result?.data?.isFoundDuplicate == true){
                        setImportXlData(result?.data?.importResponseData)
                        setDuplicateDataShow(true);
                        setSuccessShow(false)
                        setErrorDataShow(false)
                        // setBrowesShow(false);
                        // setFile("")
                    }else if(result?.data?.isValidationFailed == true){
                        setErrorDataShow(true)
                        setDuplicateDataShow(false);
                        setImportXlData(result?.data?.importResponseData)
                        setSuccessShow(false)
                        // setBrowesShow(false);
                        // setFile("")
                    }else{
                        toast.error(result?.message[0]);
                        setErrorDataShow(false)
                        setDuplicateDataShow(false);
                        setImportXlData("")
                        setSuccessShow(false)
                    }
                    
                } else {
                    setLoading(false);
                    toast.error(result?.message[0]);
                }
            }
            
        } catch (error) {
            console.log(error);
            setLoading(false);
    
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": formData,
                "uri": "/api/Vehicle/ImportTags",
                "errorNumber": "DT01",
                "errorSource": "Client",
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "ManageRFID.js",
                "functionName": "RFIDTagImport",
            };
    
            try {
                let errorResponse = await commonAPI("ErrorLogMaster", bodyError);
                console.log("statusCode", errorResponse);
                if (errorResponse?.success === true && errorResponse?.message?.length === 0) {
                    toast.error("Something went wrong");
                } else {
                    toast.error("Something went wrong");
                }
            } catch (errorLogError) {
                console.error("Error logging the error:", errorLogError);
            }
        }
    }

    const UnMapValue = (item, index) => {
        console.log("item", item)
        setSerialnumberDelete(item?.tagSerialNumber);
        setTagIdDelete(item?.tagIdHidden);
        setUnmapShow(true);
        setRFIDCardId(item?.userTagId)
        setIndexState(index)
    }

    

    const UnmapRFIDTag = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
    
        const bodyData =
        {
            "modifiedUserId": myUserData?.userId.toString(),
            "userTagId": RFIDCardId,
            "tagSerialNumber": SerialnumberDelete,
            "tagId": TagIdDelete
        }
    
        try {
            setLoading(true);
            const endPointVariableKey = {
                buildingId: BuildingId
            }
            let result = await commonAPI("UnmapUserTag", bodyData, endPointVariableKey)
            
    
            
    
            console.log("UnmapUserTag", result, bodyData);
            if (result?.success === true && result?.message?.length === 0) {
                toast.success("User Tag Unmapped");
                setUnmapShow(false);
                RFIDTagList();
                setLoading(false);
                // setImportXlData(result.data)
            } else {
                toast.error(result?.message[0]);
                setUnmapShow(false);
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
    
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Vehicle/UnmapRFIDTag",
                "errorNumber": "UT1",
                "errorSource": "Client",
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "ManageRFID.js",
                "functionName": "UnmapRFIDTag",
            };
    
            try {
                let errorResponse = await commonAPI("ErrorLogMaster", bodyError);
                console.log("statusCode", errorResponse);
                if (errorResponse?.success === true && errorResponse?.message?.length === 0) {
                    toast.error("Something went wrong");
                } else {
                    toast.error("Something went wrong");
                }
            } catch (errorLogError) {
                console.error("Error logging the error:", errorLogError);
            }
        }
    }
    

    



    return (
    <>
    {Loading? 
                <div className="loaderDiv">
                    <div className="loader"></div>
                </div> 
            :null}
    <Menus />
    <ToastContainer />
    <style>
        {`
        .table-responsive {
            height: ${slideshowHeight}px;
            overflow-y: auto;
            background-color: #f8f9fa;
        }
        `}
    </style>
    <section className="ToptoBottom">
        <div className="container-fluid p-0" style={{marginTop: "95px"}}>
        <div className="row" style={{ alignItems: 'center' }}>
        <div className="col-md-5">
            <div className="HeadingTop">
                <h3> User RFID </h3>
                <span> Manage RFID-based access control for users.</span>
            </div>
        </div>
        <div className="col-lg-3 col-md-3 col-sm-12 col-12 d-flex mb-3 mb-md-0  text-right">
            <div className="togg_area">
                <h3> User Tag Mapped </h3>
                <label className="switch1">
                <input type="checkbox" onChange={(e) => setIsMapped(e.target.checked)} />
                <span className="slider1 round1"></span>
                </label>
                <h3> Yes </h3>
            </div>
        </div>
        <div className="col-lg-2 col-md-2 col-sm-12 col-12 d-flex pr-0 mb-3 mb-md-0  text-right">
            {/* <div className="SVT">
                <span> Vehicle Type </span>
            </div> */}
            <select  value={BuildingId} onChange={(e) => {
            console.log("selection", e.target.value)
            setBuildingId(e.target.value);}} className="sltareamodal" >
                <option value="">Select Building</option>
                {BuildingList ? BuildingList?.map((item, index) =>  <option key={index} value={item?.buildingId}>{item?.buildingName}</option>): null}
            </select>
            {/* <select name="cars" id="cars" onChange={(e) => setVehicleType(e.target.value)} className="sltareamodal" >
                <option value="4WHEELER">4 Wheeler</option>
                <option value="2WHEELER">2 Wheeler</option>
            </select> */}


            
        </div>
        <div className="col-lg-2 col-md-2 text-right align-items-center mb-3 mb-md-0  text-right justify-content-end d-flex">


        <div className="filterUpperTop"> 
                                            <div className="dropdown">
                                                <FontAwesomeIcon icon={faDownload} className="reportexlpdf ReportingTools dropdown-toggle float-right" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                <ul className="dropdown-content" style={{overflow: "hidden", right: 20}}>
                                               
                                                    <li><a className="color p-0" style={{marginTop: "-6px"}} href="https://api-test-common.curo.in/api/Image/7d7cc72f-e556-46e1-88fd-600139c64e56.xlsx" > Download Template</a></li>
                                                    {/* <li><a className="color p-0" style={{marginTop: "-6px"}} href="https://api-common.curonext.com/api/Image/7d7cc72f-e556-46e1-88fd-600139c64e56.xlsx" > Download Template</a></li> */}
                                                </ul>
                                            </div>
                                             
                                        </div>
                                        
                                                    <Button onClick={() =>
                OpenModal()} className="createClr">
                {" "}
                <FontAwesomeIcon icon={faFileImport} />
                Import RFID Tag
            </Button>
            {" "} 

   

        </div>

        
        </div>
        <div className="row" id="validation">
            <div className="col-12">
                <form
                    action="#"
                    className="validation-wizard wizard-circle wizard clearfix"
                    role="application"
                    id="steps-uid-0"
                    novalidate="novalidate"
                    >
                    <div className="container-fluid">
                        <div className="row mt-2 ">
                            <div className="tableFixHead">
                                <Table  hover responsive className="mb-0">
                                    <thead>
                                        <tr>
                                            <th>Lot Number</th>
                                            <th>Serial Number</th>
                                            <th>Tag ID</th>
                                            <th>Is Mapped?</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {RFIDTagData
                                        ? RFIDTagData?.map((item, index) => (                
                                        <tr key={index} >
                                            <td className="ln" style={{backgroundColor: IndexState == index ? "#dadada" : "#fff"}}> {item?.lotNumber} </td>
                                            <td className="sn" style={{backgroundColor: IndexState == index ? "#dadada" : "#fff"}}> {item?.tagSerialNumber} </td>
                                            <td className="Ti" style={{backgroundColor: IndexState == index ? "#dadada" : "#fff"}}> {item?.tagId}</td>
                                            <td className="sn" style={{backgroundColor: IndexState == index ? "#dadada" : "#fff"}}> {item?.isMapped == false || item?.isMapped == null ? "No":"Yes"} </td>
                                            <td className="ln" style={{backgroundColor: IndexState == index ? "#dadada" : "#fff"}}>
                                                {item?.isMapped == false || item?.isMapped == null ? 
                                                    <div className=" d-flex">
                                                        <h3 className="font_trigger" onClick={() => UpdateValue(item, index)}>
                                                            <FontAwesomeIcon icon={faPenToSquare} />
                                                        </h3>
                                                        <h3 className="font_trigger" onClick={() => DeleteValue(item)}>
                                                            <FontAwesomeIcon icon={faTrashCan} />
                                                        </h3>
                                                    </div>
                                                :  
                                                <div className="">
                                                    <h3 className="font_trigger" style={{paddingLeft: 8, height: 22, width: 30}} onClick={() => UnMapValue(item, index)}>
                                                        <img src={unmapRfid} className="img" style={{width: "20px"}} />
                                                    </h3>
                                                    <p style={{fontSize: "8px"}}>Unmapped</p>
                                                </div>
                                                }  
                                            </td>
                                        </tr>)
                                    ):null}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th><input type="number" value={LotNumber} onChange={(e) => setLotNumber(e.target.value)} placeholder="Lot Number" className="footbtn" /></th>
                                            <th><input type="number" value={Serialnumber} onChange={(e) => setSerialnumber(e.target.value)} placeholder="Serial Number" className="footbtn"  /></th>
                                            <th><input type="text" value={TagId} onChange={(e) => setTagId(e.target.value)} placeholder="Tag ID" className="footbtn"  /></th>
                                            <th>
                                                <select name="cars" className="footbtn" disabled={IsIssuedDisable} value={IsIssued} onChange={(e) => setIsIssued(e.target.value)}>
                                                    <option value={true}>Yes</option>
                                                    <option value={false}>No</option>
                                                </select>
                                            </th>
                                            <th className="sn">
                                                {!UpdateBtn ? 
                                                    <div className="row mt-2" style={{display: "inline"}}>
                                                        <Button onClick={ClearValue} className="btn border bg-secondary text-white col-6">
                                                            Cancel
                                                        </Button>
                                                        <Button onClick={() =>
                                                            RFIDTagAdd()} className="createClr w-100 col-6">
                                                            {" "}
                                                            {/* <FontAwesomeIcon icon={faPlus} /> */}
                                                            Save
                                                        </Button>
                                                    </div>    
                                                   :
                                                   <div className="row mt-2" style={{display: "inline"}}>
                                                        <Button onClick={ClearValue} className="btn border bg-secondary text-white col-6">
                                                            Cancel
                                                        </Button>
                                                        <Button onClick={() =>
                                                            RFIDTagUpdate()} className="createClr w-100 col-6">
                                                            {" "}
                                                            {/* <FontAwesomeIcon icon={faPlus} /> */}
                                                            Update
                                                        </Button>
                                                    </div>    
                                                }
                                                {" "} 
                                            </th>
                                        </tr>
                                    </tfoot>
                                </Table>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
            <Modal size="md" show={show} onHide={() =>
                setShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
                <Modal.Header closeButton className='headerMDL'>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Import RFID 
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="helpingElelemnt_uuy002">
                    <div className="card-no-border">
                        <div className="row" id="validation">
                            <div className="col-12">
                                <form action="#" className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-2" novalidate="novalidate">
                                    <div className="content clearfix">
                                        <section id="steps-uid-2-p-0" role="tabpanel" aria-labelledby="steps-uid-2-h-0" className="body current pt-4" aria-hidden="false">
                                            <div className="row text-left">
                                                {BrowesShow ?
                                                    <div className="col-md-12 mb-2">
                                                        <div className="form-group">
                                                            <div className="popUpRFID">
                                                                <span> Browse : </span>
                                                                <input type="file" accept=".xlsx, .xls" onChange={(e) => [setFile(e.target.files[0]), setErrorDataShow(false), setSuccessShow(false), setDuplicateDataShow(false)]} className="footbtn" style={{display: "block"}}/>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex justify-content-between mt-1">
                                                            <div className="popUpRFID">
                                                                <h6> Allowed Files: XLSX*</h6>
                                                                <h6> Maximum File Size: 5MB*</h6>
                                                            </div>
                                                            <div className="actions clearfix justify-content-end d-flex mt-3">
                                                                <ul role="menu" aria-label="Pagination">
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                 :null}   
                                                {ErrorDataShow ? 
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <div className="error_displayMsg">
                                                                <h5> * Import Failed : Data is not in correct format. Fix following issues first, then try agian!</h5>
                                                                <div className="popUp_table009">
                                                                    <Table bordered>
                                                                        <thead>
                                                                            <tr>
                                                                                <th style={{padding: "0.5rem 0.5rem"}}>Row</th>
                                                                                <th style={{padding: "0.5rem 0.5rem"}}>Error Message</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {ImportXlData   
                                                                            ? ImportXlData?.map((item, index) => (   
                                                                            <tr>
                                                                                <td style={{padding: "0.5rem 0.5rem"}}> {item?.rowNumber} </td>
                                                                                <td style={{padding: "0.5rem 0.5rem"}}> {item?.errorMessage}</td>
                                                                            </tr>)
                                                                        ):null}
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                :null}    
                                                
                                                {DuplicateDataShow ?
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <div className="error_displayMsg">
                                                                <h5> * Import Failed : Duplicate tag id or tag serial number found. Fix following issues first, then try agian!</h5>
                                                                <div className="popUp_table009">
                                                                    <Table bordered>
                                                                        <thead>
                                                                            <tr>
                                                                                <th style={{padding: "0.5rem 0.5rem"}}>Tag Id</th>
                                                                                <th style={{padding: "0.5rem 0.5rem"}}>Tag Serial Number</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {ImportXlData
                                                                            ? ImportXlData?.map((item, index) => (   
                                                                            <tr key={index}>
                                                                                <td style={{padding: "0.5rem 0.5rem"}}> {item?.tagId} </td>
                                                                                <td style={{padding: "0.5rem 0.5rem"}}> {item?.tagSerialNumber}</td>
                                                                            </tr>)
                                                                        ):null}
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                :null}
                                                {SuccessShow ?
                                                    <div class="success_displayMsg">
                                                        <img src={success} className="img img-fluid" />  <br/>
                                                        <span> Data Imported Successfully</span>
                                                    </div>    
                                                :null}    
                                            </div>
                                        </section>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <div className="fixed_allbtn">
                    <div className="upload_btn">
                        <button type="button" className="btn border bg-white" onClick={() => setShow(false)} > Cancel</button>
                        <button type="button" className="btn btn-info"  onClick={RFIDTagImport}> Submit</button>
                    </div>
                </div>
            </Modal>

            <Modal centered show={DeleteShow} onHide={() =>
                setDeleteShow(true)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                <Modal.Body className='p-0' style={{borderRadius: "10px", overflow: "hidden"}}>
                    <div className="row px-3" id="validation">
                        <div className="col-12 bg-white pt-3 pb-2">
                            <div className="FnFItem" style={{justifyContent: "flex-start"}}>
                                <div className="FnFtxt">
                                    <h2> Delete User Tag </h2>
                                    <h3> Are you sure you want to delete? </h3>
                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                    <div className='confirmation_btn pb-4 pt-3 px-3' style={{justifyContent: "center", borderTop: "1px solid #dadada"}}>
                            <div className='both_ConfrmBTN col-6'>
                                <Button variant="danger" onClick={RFIDTagDelete}>Delete</Button>{' '}
                            </div>
                            <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
                                <Button variant="light"> Cancel</Button>{' '}
                            </div>
                        </div>
                </Modal.Body>
            </Modal>

            <Modal centered show={UnmapShow} onHide={() =>
            setUnmapShow(true)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                <Modal.Body className='p-0' style={{borderRadius: "10px", overflow: "hidden"}}>
                    <div className="row px-3" id="validation">
                        <div className="col-12 bg-white pt-3 pb-2">
                            <div className="FnFItem" style={{justifyContent: "flex-start"}}>
                                <div className="FnFtxt">
                                    <h2> Unmap User Tag </h2>
                                    <h3> Are you sure you want to unmap this tag? </h3>
                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                    <div className='confirmation_btn pb-4 pt-3 px-3' style={{justifyContent: "center", borderTop: "1px solid #dadada"}}>
                            <div className='both_ConfrmBTN col-6'>
                                <Button variant="primary" onClick={UnmapRFIDTag}>Unmap User Tag</Button>{' '}
                            </div>
                            <div className='both_ConfrmBTN col-6' onClick={() => [setUnmapShow(false), setIndexState(null)]} >
                                <Button variant="light"> Cancel</Button>{' '}
                            </div>
                        </div>
                </Modal.Body>
            </Modal>
        </div>
    </section>
    </>
    );
}
export default ManageUserRfid;